module.exports = __webpack_public_path__ + "static/media/lion.1632a957.jpg";